module.exports = __webpack_public_path__ + "img/soja.db3cf274.svg";